import { getUserId } from "../../../../Utils/Common/Library";
import { Groups } from "../Data/Groups";
import { Parameters } from "../Data/Parameters";
import { WorkflowProcesser } from "../WorkflowProcesser";

export const extractDimensionStructure = (dimensionStructure) => {
  const [group2, group1, parameter] = dimensionStructure.split("");
  return {
    group2,
    group1,
    parameter,
  };
};

export const extractDiscardRules = (discardRule) => {
  const [group2, group1, parameter] = discardRule.split("");
  return {
    group2,
    group1,
    parameter,
  };
};

export const extractAddRules = (addRule) => {
  const [group2, group1, parameter] = addRule.split("");
  return {
    group2,
    group1,
    parameter,
  };
};

export const extractWeightRules = (weightRule) => {
  console.log("Weight rule", weightRule);
  const [group2, group1, parameter] = weightRule.split("");
  return {
    group2,
    group1,
    parameter,
  };
};

export const extractTargetRules = (targetRule) => {
  console.log("Target rule: ", targetRule);
  const enabled = targetRule[0];
  const mapped = targetRule[3];
  const targetType = targetRule.substring(1, 3);
  return { enabled, targetType, mapped };
};

export const getGroupLibrary = (level) => {
  const groups = Groups.map((group) =>
    group.GroupLevel === level
      ? { label: group.GroupName, value: group.DocumentID }
      : 0
  );

  return groups.filter((group) => group !== 0);
};

export const getParameterLibrary = () => {
  return Parameters.map((param) => ({
    label: param.ParameterName,
    value: param.DocumentID,
  }));
};

export const getTableHeading = (type) => {
  switch (type) {
    case "g2":
      return ["Select", "Group Name"];
    case "g1":
      return ["Select", "Group Name"];
    case "p":
      return ["Select", "Parameter Name"];
    default:
      return [];
  }
};
export const isEnabled = (value) => value === "E";
export const isDisabled = (value) => value === "D";
export const isUserDefined = (value) => value === "U";
export const isPermitted = (value) => value === "P";
export const isRestricted = (value) => value === "R";
export const isNA = (value) => value === "N";
export const isNoWeights = (value) => value === "N";
export const isAggregated = (value) => value === "A";
export const isDefinedInMap = (value) => value === "D";
export const isMapped = (value) => value === "M";
export const isMappedEditable = (value) => value === "E";
export const isLibrary = (value) => value === "L";

export const createTargets = (periodType, planStart, planEnd) => {
  const periodMap = {
    PS: { type: "A", values: ["A"] },
    Q: { type: "Q", value: ["Q1", "Q2", "Q3", "Q4"] },
    H: { type: "H", value: ["H1", "H2"] },
  };

  const data = periodMap[periodType];

  if (!data) return [];

  const type = data.type;
  const values = data.values;

  const ans = [];
  values.forEach((value) => {
    ans.push({
      TargetPeriodType: type,
      TargetTillDate: planEnd,
      TargetFromDate: planStart,
      TargetPeriodValue: value,
      MultipleTargets: [],
      SingleTarget: "",
      Weight: "0",
    });
  });

  return ans;
};

export const validateParameters = (parameters) => {
  let totalWeight = 0;
  parameters.forEach((p) => {
    p.Targets.forEach((t) => {
      totalWeight += parseInt(t.Weight);
    });
  });

  if (totalWeight > 100) {
    return `Total Weight is exceeding 100 (Current Total Weight: ${totalWeight})`;
  } else if (totalWeight < 100) {
    return `Total Weight is less than 100 (Current Total Weight: ${totalWeight})`;
  } else {
    return "";
  }
};

export function calculateAggregateScore(MPPDocument, Dimensions) {
  if (!MPPDocument) {
    return undefined;
  }

  const data = MPPDocument.Data;
  if (!data) return undefined;

  const dimensionsInMPP = data.Dimension;
  if (!dimensionsInMPP || !Array.isArray(dimensionsInMPP)) return undefined;
  if (!Dimensions || !Array.isArray(Dimensions)) return undefined;

  const aggregatePlanScore = data.AggregatePlanScore;
  if (!aggregatePlanScore) {
    return undefined;
  }

  let aggregatedPlanScore = 0;

  if (aggregatePlanScore.toLowerCase() === "e") {
    let dimensionsWeightSum = 0;

    Dimensions.forEach((dimension) => {
      const dimensionID = dimension.DimensionID?.trim();
      if (!dimensionID) return; // Skip this dimension

      let aggregationRating = "";
      let dimWeight = "";

      // Find matching dimension in MPP
      for (const DimensionInMPP of dimensionsInMPP) {
        const dimID = DimensionInMPP.DimensionID?.trim();
        if (!dimID) continue;

        if (dimID.toLowerCase() === dimensionID.toLowerCase()) {
          aggregationRating = DimensionInMPP.AggregationRating || "";
          dimWeight = DimensionInMPP.PlanDimensionWeight || "";
          break;
        }
      }

      const dimensionWeight = dimWeight === "" ? 0 : parseFloat(dimWeight);
      dimensionsWeightSum += dimensionWeight;

      // Determine which actor's score to use
      let actor;
      if (aggregationRating.toLowerCase() === "ae") {
        actor = "AppraiseeAggregateScore";
      } else if (aggregationRating.toLowerCase() === "ar") {
        actor = "AppraiserAggregateScore";
      } else {
        actor = "ReviewerAggregateScore";
      }

      const dimensionAggregateScore = dimension.DimensionAggregateScore;
      if (!dimensionAggregateScore) return;

      const score = dimensionAggregateScore[actor] || "";
      const scoreValue = score === "" ? 0 : parseFloat(score);

      // Add weighted score to total
      aggregatedPlanScore += dimensionWeight * scoreValue;
    });

    // Avoid division by zero
    if (dimensionsWeightSum > 0) {
      // Calculate final score by dividing by total weight
      aggregatedPlanScore /= dimensionsWeightSum;
      return aggregatedPlanScore;
    }
  }

  return undefined;
}

export const getCommenterRole = (workflow) => {
  const workflowProcesser = new WorkflowProcesser(workflow);
  const viewerIndex = workflowProcesser.getStepOfLoggedInUser(getUserId());
  const ViewerStep = workflowProcesser.getStepByIndex(viewerIndex);
  const ViewerLabel = ViewerStep?.StepOwnerLabel;
  return ViewerLabel || "";
};

export const isCommentsChanged = (prevComments, currComments) => {
  if (!prevComments || !currComments) return false;
  if (prevComments.length !== currComments.length) return true;
  let n = prevComments.length;
  for (let i = 0; i < n; i++) {
    if (prevComments[i].Comment !== currComments[i].Comment) {
      return true;
    }
  }
  return false;
};
